import React from 'react';

function FlagIcon({ flagged }) {
  return flagged ? (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 22 22" enableBackground="new 0 0 22 22">
      <title>Flag</title>
      <path fill="#0D47A1" d="M1.59,16.19l4.25,4.22c0.78,0.78,2.05,0.78,2.84,0 L20.7,8.33c0.64-0.63,0.18-1.71-0.72-1.7l-3.69,0.05c-0.56,0.01-1.02-0.45-1.02-1.01l0.05-3.66c0.01-0.89-1.08-1.35-1.71-0.72 L1.59,13.38C0.8,14.16,0.8,15.42,1.59,16.19" />
    </svg>
  ) : (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 22 22" enableBackground="new 0 0 22 22">
      <title>Flag</title>
      <path fill="#0D47A1" d="M3.71,14.08l9.58-9.65l-0.03,2.24l0,0c-0.01,1.12,0.9,2.03,2.03,2.02l2.25-0.03l-9.57,9.65 c-0.39,0.39-1.03,0.39-1.42,0l-2.84-2.82C3.32,15.1,3.32,14.47,3.71,14.08 M1.59,16.19l4.25,4.22c0.78,0.78,2.05,0.78,2.84,0 L20.7,8.33c0.64-0.63,0.18-1.71-0.72-1.7l-3.69,0.05c-0.56,0.01-1.02-0.45-1.02-1.01l0.05-3.66c0.01-0.89-1.08-1.35-1.71-0.72 L1.59,13.38C0.8,14.16,0.8,15.42,1.59,16.19" />
    </svg>
  );
}

export default FlagIcon;



// WEBPACK FOOTER //
// ./src/components/icons/FlagIcon.js